import React from 'react';
import Container from "../../components/container/container-component";
import "./add-report.css";
import Input from "../../components/input/input-component";
import Button from "../../components/button/button-component";

const AddReportComponent = (
  {
    reportUrl,
    name,
    password,
    loading,
    addReport,
    error,
    inputChange,
    addNotificationSuccess,
    addNotificationError
  }
) => {
  return (
    <Container
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
    >
      <h2>Add old report</h2>
      <form className="add_report_form" onSubmit={e => {
        e.preventDefault();
        addReport()
      }}>
        <Input
          name="Report URL"
          type="text"
          value={reportUrl.value}
          error={reportUrl.error}
          inputChange={e => inputChange({ inputValue: e.target.value, inputName: 'reportUrl'})}
        />
        <Input
          name="Name"
          type="text"
          value={name.value}
          error={name.error}
          inputChange={e => inputChange({ inputValue: e.target.value, inputName: 'name'})}
        />
        <Input
          name="Password"
          type="password"
          value={password.value}
          error={password.error}
          inputChange={e => inputChange({ inputValue: e.target.value, inputName: 'password'})}
        />
        <div className="add_report_form__button_wrapper">
          <Button
            name="Add Report"
            primaryBtn
            async
            loading={loading}
            width="35%"
            height="100%"
            type="submit"
            spinnerRight="15px"
            spinnerTop="15px"
          />
        </div>

      </form>
    </Container>
  )
};

export default AddReportComponent;


// WEBPACK FOOTER //
// ./src/modules/add-report/add-report-component.js